/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../apiConfigs/axiosInstance";
import { ERROR__TOASTER } from "../../../../helpers/utils/TosterError";
import { renderDynamicUrlFromState } from "../../../../helpers/utils/urlHelper";

export interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const fetchInterviewDetails = createAsyncThunk(
  "interviewLogDetail/fetchInterviewDetails",
  async (interviewId: string, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.get(
        `https://backend.joindojo.ai/api/company-user/interviews/public/${interviewId}`
      );
      return response.data;
    } catch (error: any) {
      ERROR__TOASTER(error);
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch interview details"
      );
    }
  }
);

export const fetchFeedback = createAsyncThunk(
  "interviewLogDetail/fetchFeedback",
  async (interviewId: string, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.get(
        `https://backend.joindojo.ai/api/company-user/interviews/public/${interviewId}/feedback`
      );
      return response.data;
    } catch (error: any) {
      ERROR__TOASTER(error);
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch feedback"
      );
    }
  }
);

export const fetchEvaluations = createAsyncThunk(
  "interviewLogDetail/fetchEvaluations",
  async (interviewId: string, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.get(
        `https://backend.joindojo.ai/api/company-user/interviews/public/${interviewId}/evaluations`
      );
      return response.data;
    } catch (error: any) {
      ERROR__TOASTER(error);
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch evaluations"
      );
    }
  }
);

export const fetchAudio = createAsyncThunk(
  "interviewLogDetail/fetchAudio",
  async (interviewId: string, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.get(
        `https://backend.joindojo.ai/api/company-user/interviews/public/${interviewId}/audio`
      );
      return response.data;
    } catch (error: any) {
      ERROR__TOASTER(error);
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch audio"
      );
    }
  }
);
